<template>
  <div class="news-item" v-if="newsObject">
    <div>
      <b-input v-model="newsObject.title" placeholder="Заголовок"/>
      <el-date-picker class="date-picker"
        v-model="date"
        :editable="false"
        type="date"
        placeholder="Дата">
      </el-date-picker>
      <Editor
      :editorToolbar="customToolbar"
      placeholder="Текст информации"
      v-model="text"/>
    </div>
    <div class="centered">
      <span class="button-wrapper" @click="handleLoadNewsPhoto">
        <a class="button is-info">+</a> Добавить фото
      </span>
      <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
    </div>
    <div v-if="newsObject.photos.length">
      <swiper :options="swiperOption">
        <swiper-slide  v-for="photo in newsObject.photos" :key="photo">
          <div class="photo-container column" v-if="isNew">
            <div class="centered">
              <img :src="photo.photo" />
              <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDeletePhoto(photo)"/>
            </div>
          </div>
          <div class="photo-container column" v-else>
            <div class="centered">
              <img :src='"/upload/photos/" + photo' class="column"/>
              <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDeletePhoto(photo)"/>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <span class="button is-fullwidth" @click="save">СОХРАНИТЬ</span>
    <router-link :to="{ name: 'News' }" class="button is-fullwidth">ОТМЕНА</router-link>
    <span class="button is-fullwidth is-danger" @click="deleteNews(newsObject.id)" v-if="!isNew">УДАЛИТЬ</span>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import deepcopy from 'deepcopy'
import { VueEditor as Editor } from 'vue2-editor'

export default {
  name: 'NewsItem',
  data () {
    return {
      date: '',
      text: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}]
      ],
      isNew: true,
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        autoHeight: false
      }
    }
  },
  created () {
    this.isNew = !this.$route.params.id
    this.getNews()
  },
  computed: {
    ...mapState(['news']),
    newsObject () {
      if (this.news.length && this.$route.params.id) {
        const current = this.news.find(n => n.id === this.$route.params.id)
        this.text = current.text
        this.date = current.date
        return deepcopy(current)
      } else {
        this.date = new Date()
        this.text = ''
        return {
          date: new Date(),
          text: '',
          title: '',
          photos: []
        }
      }
    }
  },
  methods: {
    ...mapActions(['deleteNews', 'updateNews', 'loadNewsPhoto', 'getNews', 'addNews']),
    handleLoadNewsPhoto () {
      this.$refs.loadPhotoButton.click()
    },
    loadPhoto (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      if (this.isNew) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = (e) => {
          this.newsObject.photos.push({ photo: e.target.result, data: formData })
          this.$forceUpdate()
        }
      } else {
        this.newsObject.photos.push(file.name)
        this.loadNewsPhoto({ formData, id: this.newsObject.id })
      }
    },
    handleDeletePhoto (data) {
      if (this.isNew) {
        this.newsObject.photos = this.newsObject.photos.filter(p => p.photo !== data.photo)
      } else {
        this.newsObject.photos = this.newsObject.photos.filter(p => p !== data)
      }
      this.$forceUpdate()
    },
    save () {
      this.newsObject.text = this.text
      this.newsObject.date = this.date
      if (this.isNew) {
        this.addNews(this.newsObject)
      } else {
        this.updateNews(this.newsObject)
      }
    }
  },
  components: { Editor }
}
</script>
<style scoped>
.news-item {
  position: relative;
  padding: 25px;
  margin: 15px auto;
  max-width: 600px;
}
.delete-icon {
  top: -8px;
  right: -8px;
}
.phpto-container {
  position: relative;
}
.photo-container .delete-icon{
  top: 5px;
  right: 5px;
}
.back-button {
  margin: 20px 0 0;
}
.date-picker {
  width: 100%;
  margin: 15px 0 0;
}
</style>
<style>
.el-date-picker {
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// NewsItem.vue?4749c5aa